function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module list/utils
 */
import { getFillerOffset } from '@ckeditor/ckeditor5-engine/src/view/containerelement';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
/**
 * Creates a list item {@link module:engine/view/containerelement~ContainerElement}.
 *
 * @param {module:engine/view/downcastwriter~DowncastWriter} writer The writer instance.
 * @returns {module:engine/view/containerelement~ContainerElement}
 */

export function createViewListItemElement(writer) {
  var viewItem = writer.createContainerElement('li');
  viewItem.getFillerOffset = getListItemFillerOffset;
  return viewItem;
}
/**
 * Helper function that creates a `<ul><li></li></ul>` or (`<ol>`) structure out of the given `modelItem` model `listItem` element.
 * Then, it binds the created view list item (<li>) with the model `listItem` element.
 * The function then returns the created view list item (<li>).
 *
 * @param {module:engine/model/item~Item} modelItem Model list item.
 * @param {module:engine/conversion/upcastdispatcher~UpcastConversionApi} conversionApi Conversion interface.
 * @returns {module:engine/view/containerelement~ContainerElement} View list element.
 */

export function generateLiInUl(modelItem, conversionApi) {
  var mapper = conversionApi.mapper;
  var viewWriter = conversionApi.writer;
  var listType = modelItem.getAttribute('listType') == 'numbered' ? 'ol' : 'ul';
  var viewItem = createViewListItemElement(viewWriter);
  var viewList = viewWriter.createContainerElement(listType, null);
  viewWriter.insert(viewWriter.createPositionAt(viewList, 0), viewItem);
  mapper.bindElements(modelItem, viewItem);
  return viewItem;
}
/**
 * Helper function that inserts a view list at a correct place and merges it with its siblings.
 * It takes a model list item element (`modelItem`) and a corresponding view list item element (`injectedItem`). The view list item
 * should be in a view list element (`<ul>` or `<ol>`) and should be its only child.
 * See comments below to better understand the algorithm.
 *
 * @param {module:engine/view/item~Item} modelItem Model list item.
 * @param {module:engine/view/containerelement~ContainerElement} injectedItem
 * @param {module:engine/conversion/upcastdispatcher~UpcastConversionApi} conversionApi Conversion interface.
 * @param {module:engine/model/model~Model} model The model instance.
 */

export function injectViewList(modelItem, injectedItem, conversionApi, model) {
  var injectedList = injectedItem.parent;
  var mapper = conversionApi.mapper;
  var viewWriter = conversionApi.writer; // The position where the view list will be inserted.

  var insertPosition = mapper.toViewPosition(model.createPositionBefore(modelItem)); // 1. Find the previous list item that has the same or smaller indent. Basically we are looking for the first model item
  // that is a "parent" or "sibling" of the injected model item.
  // If there is no such list item, it means that the injected list item is the first item in "its list".

  var refItem = getSiblingListItem(modelItem.previousSibling, {
    sameIndent: true,
    smallerIndent: true,
    listIndent: modelItem.getAttribute('listIndent')
  });
  var prevItem = modelItem.previousSibling;

  if (refItem && refItem.getAttribute('listIndent') == modelItem.getAttribute('listIndent')) {
    // There is a list item with the same indent - we found the same-level sibling.
    // Break the list after it. The inserted view item will be added in the broken space.
    var viewItem = mapper.toViewElement(refItem);
    insertPosition = viewWriter.breakContainer(viewWriter.createPositionAfter(viewItem));
  } else {
    // There is no list item with the same indent. Check the previous model item.
    if (prevItem && prevItem.name == 'listItem') {
      // If it is a list item, it has to have a lower indent.
      // It means that the inserted item should be added to it as its nested item.
      insertPosition = mapper.toViewPosition(model.createPositionAt(prevItem, 'end'));
    } else {
      // The previous item is not a list item (or does not exist at all).
      // Just map the position and insert the view item at the mapped position.
      insertPosition = mapper.toViewPosition(model.createPositionBefore(modelItem));
    }
  }

  insertPosition = positionAfterUiElements(insertPosition); // Insert the view item.

  viewWriter.insert(insertPosition, injectedList); // 2. Handle possible children of the injected model item.

  if (prevItem && prevItem.name == 'listItem') {
    var prevView = mapper.toViewElement(prevItem);
    var walkerBoundaries = viewWriter.createRange(viewWriter.createPositionAt(prevView, 0), insertPosition);
    var walker = walkerBoundaries.getWalker({
      ignoreElementEnd: true
    });

    var _iterator = _createForOfIteratorHelper(walker),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;

        if (value.item.is('li')) {
          var breakPosition = viewWriter.breakContainer(viewWriter.createPositionBefore(value.item));
          var viewList = value.item.parent;
          var targetPosition = viewWriter.createPositionAt(injectedItem, 'end');
          mergeViewLists(viewWriter, targetPosition.nodeBefore, targetPosition.nodeAfter);
          viewWriter.move(viewWriter.createRangeOn(viewList), targetPosition);
          walker.position = breakPosition;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else {
    var nextViewList = injectedList.nextSibling;

    if (nextViewList && (nextViewList.is('ul') || nextViewList.is('ol'))) {
      var lastSubChild = null;

      var _iterator2 = _createForOfIteratorHelper(nextViewList.getChildren()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          var modelChild = mapper.toModelElement(child);

          if (modelChild && modelChild.getAttribute('listIndent') > modelItem.getAttribute('listIndent')) {
            lastSubChild = child;
          } else {
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (lastSubChild) {
        viewWriter.breakContainer(viewWriter.createPositionAfter(lastSubChild));
        viewWriter.move(viewWriter.createRangeOn(lastSubChild.parent), viewWriter.createPositionAt(injectedItem, 'end'));
      }
    }
  } // Merge the inserted view list with its possible neighbor lists.


  mergeViewLists(viewWriter, injectedList, injectedList.nextSibling);
  mergeViewLists(viewWriter, injectedList.previousSibling, injectedList);
}
/**
 * Helper function that takes two parameters that are expected to be view list elements, and merges them.
 * The merge happens only if both parameters are list elements of the same type (the same element name and the same class attributes).
 *
 * @param {module:engine/view/downcastwriter~DowncastWriter} viewWriter The writer instance.
 * @param {module:engine/view/item~Item} firstList The first element to compare.
 * @param {module:engine/view/item~Item} secondList The second element to compare.
 * @returns {module:engine/view/position~Position|null} The position after merge or `null` when there was no merge.
 */

export function mergeViewLists(viewWriter, firstList, secondList) {
  // Check if two lists are going to be merged.
  if (!firstList || !secondList || firstList.name != 'ul' && firstList.name != 'ol') {
    return null;
  } // Both parameters are list elements, so compare types now.


  if (firstList.name != secondList.name || firstList.getAttribute('class') !== secondList.getAttribute('class')) {
    return null;
  }

  return viewWriter.mergeContainers(viewWriter.createPositionAfter(firstList));
}
/**
 * Helper function that for a given `view.Position`, returns a `view.Position` that is after all `view.UIElement`s that
 * are after the given position.
 *
 * For example:
 * `<container:p>foo^<ui:span></ui:span><ui:span></ui:span>bar</container:p>`
 * For position ^, the position before "bar" will be returned.
 *
 * @param {module:engine/view/position~Position} viewPosition
 * @returns {module:engine/view/position~Position}
 */

export function positionAfterUiElements(viewPosition) {
  return viewPosition.getLastMatchingPosition(function (value) {
    return value.item.is('uiElement');
  });
}
/**
 * Helper function that searches for a previous list item sibling of a given model item that meets the given criteria
 * passed by the options object.
 *
 * @param {module:engine/model/item~Item} modelItem
 * @param {Object} options Search criteria.
 * @param {Boolean} [options.sameIndent=false] Whether the sought sibling should have the same indentation.
 * @param {Boolean} [options.smallerIndent=false] Whether the sought sibling should have a smaller indentation.
 * @param {Number} [options.listIndent] The reference indentation.
 * @returns {module:engine/model/item~Item|null}
 */

export function getSiblingListItem(modelItem, options) {
  var sameIndent = !!options.sameIndent;
  var smallerIndent = !!options.smallerIndent;
  var indent = options.listIndent;
  var item = modelItem;

  while (item && item.name == 'listItem') {
    var itemIndent = item.getAttribute('listIndent');

    if (sameIndent && indent == itemIndent || smallerIndent && indent > itemIndent) {
      return item;
    }

    item = item.previousSibling;
  }

  return null;
}
export function findInRange(range, comparator) {
  var _iterator3 = _createForOfIteratorHelper(range.getItems()),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var item = _step3.value;
      var result = comparator(item);

      if (result) {
        return result;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}
/**
 * Helper method for creating a UI button and linking it with an appropriate command.
 *
 * @private
 * @param {module:core/editor/editor~Editor} editor The editor instance to which the UI component will be added.
 * @param {String} commandName The name of the command.
 * @param {Object} label The button label.
 * @param {String} icon The source of the icon.
 */

export function createUIComponent(editor, commandName, label, icon) {
  editor.ui.componentFactory.add(commandName, function (locale) {
    var command = editor.commands.get(commandName);
    var buttonView = new ButtonView(locale);
    buttonView.set({
      label: label,
      icon: icon,
      tooltip: true,
      isToggleable: true
    }); // Bind button model to command.

    buttonView.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled'); // Execute command.

    buttonView.on('execute', function () {
      return editor.execute(commandName);
    });
    return buttonView;
  });
} // Implementation of getFillerOffset for view list item element.
//
// @returns {Number|null} Block filler offset or `null` if block filler is not needed.

function getListItemFillerOffset() {
  var hasOnlyLists = !this.isEmpty && (this.getChild(0).name == 'ul' || this.getChild(0).name == 'ol');

  if (this.isEmpty || hasOnlyLists) {
    return 0;
  }

  return getFillerOffset.call(this);
}